import PropTypes from 'prop-types';
import React, { useState } from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';

const newId = () => Math.random().toString(16).slice(2, 10);

export default function Checklist({ task, onChange }) {
  const [draft, setDraft] = useState('');
  const steps = task.checklist || [];
  const add = () => {
    const text = draft.trim();
    if (!text) return;
    onChange([...steps, { id: newId(), text, done: false }]);
    setDraft('');
  };
  return (
    <div className={s.section}>
      <h3 className={s.sectionTitle}>Checklist</h3>
      {steps.length > 0 && (
        <ul className={s.stepList}>
          {steps.map((step) => (
            <li key={step.id} className={s.step}>
              <input
                type="checkbox"
                checked={!!step.done}
                aria-label={step.text}
                onChange={(e) => onChange(steps.map((x) => (x.id === step.id ? { ...x, done: e.target.checked } : x)))}
              />
              <span className={`${s.stepText} ${step.done ? s.stepDone : ''}`}>{step.text}</span>
              <button
                type="button"
                className={s.x}
                aria-label={`Remove step ${step.text}`}
                onClick={() => onChange(steps.filter((x) => x.id !== step.id))}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className={s.addRow}>
        <input
          className={s.input}
          value={draft}
          placeholder="Add a step"
          aria-label="New step"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
        />
        <button type="button" className={s.btn} onClick={add}>Add</button>
      </div>
    </div>
  );
}

Checklist.propTypes = {
  task: taskShape.isRequired,
  onChange: PropTypes.func.isRequired,
};
